import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getNews } from '../lib/microcms';
import { News } from '../types/news';
import { usePageMeta } from '../hooks/usePageMeta';

export const HomePage = () => {
  const [latestNews, setLatestNews] = useState<News[]>([]);

  usePageMeta({
    title: 'Web制作・デザイン',
    description: 'WAOUHの公式サイトです。Web制作や活動の最新情報をお届けします。',
    path: '/',
  });

  useEffect(() => {
    const run = async () => {
      const data = await getNews();
      setLatestNews(data.slice(0, 3));
    };

    run();
  }, []);

  return (
    <>
      <section className="hero">
        <p className="hero-kicker">creative portfolio website</p>
        <h1>
          WAOUHの公式サイトです。<br />
          Web制作や活動の最新情報をお届けします。
        </h1>
        <p className="hero-text">
          日々の活動や制作のことを発信しています。<br />
          このサイトではプロフィールやお知らせ、ブログをご覧いただけます。<br />
          ご依頼やご相談はお問い合わせフォームからお気軽にご連絡ください。
        </p>
        <div className="hero-actions">
          <Link to="/news" className="btn btn-ghost">
            お知らせを見る
          </Link>
          <Link to="/blog" className="btn btn-primary">
            ブログを見る
          </Link>
        </div>
      </section>

      <section className="home-news">
        <div className="home-news-head">
          <h2>Latest News</h2>
          <Link to="/news" className="read-more read-more-inline">
            すべて見る
          </Link>
        </div>

        <div className="home-news-list">
          {latestNews.map((item) => (
            <article key={item.id} className="home-news-item">
              <p className="meta">{dayjs(item.publishedAt).format('YYYY.MM.DD')}</p>
              <h3>
                <Link to={`/news/${item.id}`} className="news-title-link">
                  {item.title}
                </Link>
              </h3>
            </article>
          ))}
        </div>
      </section>

      <section className="profile">
        <h2 className="profile-title">Profile</h2>
        <p className="profile-lead">
          Webサイトの設計から実装・デザインまで、トータルでサポートします。
        </p>
        <ul className="profile-list">
          <li>
            <span className="profile-label">実装・デザイン</span>
            Webサイトの実装およびデザインに対応。
            要件に合わせたUIの構築から、細部の調整まで一貫して担当します。
          </li>
          <li>
            <span className="profile-label">WordPress</span>
            テーマ開発・カスタマイズ・プラグイン対応など、
            WordPressを使ったWebサイトの構築が可能です。
          </li>
          <li>
            <span className="profile-label">経験</span>
            スタートアップから大規模企業まで、様々な業種のWebプロジェクトに関わってきました。設計から実装まで、トータルでのサポート経験があります。
          </li>
        </ul>
        <Link to="/contact" className="btn btn-primary profile-cta">
          お問い合わせはこちら
        </Link>
      </section>
    </>
  );
};
